import { createAction, props } from "@ngrx/store";
export const arcgisItemsSearch = createAction("[tab-arcgis-items] ArcgisItemsSearch", props());
